import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { TrackeritemRest } from '../../services/trackeritem.rest';
import { UiService } from '../../../../core/services/core.ui.service';
import { StateService } from '@uirouter/angular';
import { GfTranslateService } from '../../../../core/services/core.translate.service';
import { ModalComponent } from '../../../../core/config/core.modal-helpers';

@Component({
  selector: 'trackeritem-clone-modal',
  template: require('./trackeritem.clone.component.html'),
})
export class TrackeritemCloneModalComponent extends ModalComponent implements OnInit {
  @Input() trackeritem: any;
  @Input() tracker: any;
  @Input() project: any;
  @Output() onClone: EventEmitter<any> = new EventEmitter<any>();

  copyAttachments: boolean = false;
  customSummary: string = '';
  isCloning: boolean = false;
  errors: any = {};

  constructor(
    private trackeritemRest: TrackeritemRest,
    private uiService: UiService,
    private stateService: StateService,
    private translateService: GfTranslateService
  ) {
    super();
  }

  ngOnInit(): void {
    // Prepopulate with the original summary so user can modify it
    this.customSummary = this.trackeritem?.summary || '';
    this.copyAttachments = false;
  }

  submitClone(): void {
    this.isCloning = true;
    this.errors = {};

    const cloneData = {
      copyAttachments: this.copyAttachments,
      summary: this.customSummary.trim() || null
    };

    this.trackeritemRest.clone(this.trackeritem.id, cloneData)
      .then((response: any) => {
        this.isCloning = false;
        this.closeModal();
        
        this.uiService.message.showSuccess(
          this.translateService.translate('Tracker item cloned successfully. Redirecting to the new item...'),
          this.translateService.translate('Clone Tracker Item')
        );

        // Redirect to the new cloned tracker item
        this.stateService.go(
          'home.project.summary.tracker.item.edit',
          {
            unixName: this.project.unixName,
            tracker: this.tracker.id,
            id: response.id
          },
          { inherit: false }
        );

        this.onClone.emit(response);
      })
      .catch((error: any) => {
        this.isCloning = false;
        this.errors = error;
        this.uiService.message.showError(
          this.translateService.translate('There was an error cloning the tracker item. Please try again.'),
          this.translateService.translate('Clone Tracker Item')
        );
      });
  }
}
